import { render, staticRenderFns } from "./SkinProblemRow.vue?vue&type=template&id=3e22a3e5&scoped=true&"
import script from "./SkinProblemRow.vue?vue&type=script&lang=js&"
export * from "./SkinProblemRow.vue?vue&type=script&lang=js&"
import style0 from "./SkinProblemRow.vue?vue&type=style&index=0&id=3e22a3e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22a3e5",
  null
  
)

export default component.exports